"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);

// src/support/strings.ts
var strings_exports = {};
__export(strings_exports, {
  humanize: () => humanize,
  titleize: () => titleize,
  truncate: () => truncate,
  uuidRegex: () => uuidRegex
});
module.exports = __toCommonJS(strings_exports);
function titleize(input) {
  return input.split(" ").map(
    (word) => word.substr(0, 1).toUpperCase() + word.substr(1).toLowerCase()
  ).join(" ");
}
function humanize(input) {
  const replaced = input.trim().replace(/[_]+/g, " ").replace(/([a-z])([A-Z])/g, (_, first, second) => `${first} ${second}`).replace(/\bpick up\b/i, "pickup").replace(/\bin venue\b/i, "in-venue").replace(/^menu$/i, "visual menu");
  return (replaced.substr(0, 1).toUpperCase() + replaced.substr(1).toLowerCase()).replace(/\bpos\b/i, "POS");
}
function truncate(input, maxLength, ellipsis = "\u2026") {
  if (input.length > maxLength) {
    return input.substring(0, maxLength).concat(ellipsis);
  }
  return input;
}
var uuidRegex = /[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}/;
